<a [href]="href" class="col">
  <div class="d-flex justify-content-center w-100 align-items-center">
    <img [src]="iconSrc" alt="" height="25" />
    <app-contact-btn [href]="href" label="" type="Address"></app-contact-btn>
  </div>
</a>
